import { useEffect, useState } from "react";
import { Periods } from "../helpers/enums";
import { getDateRange } from "../helpers/general";

const filters = [
  {
    label: "Dernier",
    key: "latest",
    value: "latest",
  },
  {
    label: "Aujourd'hui",
    key: Periods.today,
    value: Periods.today,
  },
  {
    label: "Hier",
    key: Periods.yesterday,
    value: Periods.yesterday,
  },
  {
    label: "Derniers 7 jours",
    key: Periods.last7Days,
    value: Periods.last7Days,
  },
  {
    label: "Mois en cours",
    key: Periods.currentMonth,
    value: Periods.currentMonth,
  },
  {
    label: "Derniers 3 mois",
    key: Periods.last3Months,
    value: Periods.last3Months,
  },
];

type DateFilterProps = {
  onChange: (dates: Dates) => void;
  onPeriodChange?: (period: Periods | null) => void;
  defaultPeriod?: Periods;
  label?: string;
};
export default function DateFilters(props: DateFilterProps) {
  const { onChange, onPeriodChange, label, defaultPeriod } = props;
  const [selectedDate, onSelectDate] = useState<string | null>(
    defaultPeriod ?? null,
  );

  useEffect(() => {
    if (defaultPeriod) {
      onSelectDate(defaultPeriod);
    }
  }, [defaultPeriod]);

  useEffect(() => {
    if (selectedDate !== "latest" && selectedDate) {
      const dateRange = getDateRange(selectedDate as Periods);
      onChange({
        from: dateRange[0].toISOString(),
        to: dateRange[1].toISOString(),
      });
      onPeriodChange?.(selectedDate as Periods);
    } else {
      onChange({
        from: "",
        to: "",
      });
      onPeriodChange?.(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  return (
    <div>
      {label && <label htmlFor="filter">{label}</label>}
      <select
        name="date_filter"
        id="filter"
        onChange={(e) => onSelectDate(e.target.value)}
        value={selectedDate!}
      >
        {filters.map((filter) => (
          <option value={filter.value} key={filter.value}>
            {filter.label}
          </option>
        ))}
      </select>
    </div>
  );
}
